
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DialogBanner from "@/components/app/DialogBanner.vue";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import Booking from "@/domain/booking/Booking";
import TimeService from "@/services/TimeService";
import Restaurant from "@/domain/restaurant/Restaurant";
import RemoteServices from "@/services/RemoteServices";
import BookingOverviewComponent from "@/components/booking/components/BookingOverviewComponent.vue";
import BookingOverview from "@/components/booking/components/BookingOverview.vue";
import { VuetifyTextInput } from "@/plugins/vuetify";
@Component({
  components: {
    BookingOverview,
    BookingOverviewComponent,
    ConfirmationDialog,
    DialogBanner
  }
})
export default class SearchBookingDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  page: number = 0;

  pageSize = 25;

  loading: boolean = false;

  bookings: Booking[] = [];

  searchString: string = "";

  @Prop({ default: "" })
  initialSearch!: string;

  @Prop({ default: "" })
  defaultCustomerName!: string;

  previousSearchString = "";

  expanded: Booking[] = [];

  tab = 0;

  headers = [
    {
      text: this.$t("booking.date"),
      value: "bookingDateTime",
      groupable: false,
      sortable: true,
      width: 200
    },
    {
      text: this.$t("booking.numberOfPeople"),
      value: "numberOfPeople",
      groupable: false,
      sortable: false,
      width: 100
    },
    {
      text: this.$t("booking.customerName"),
      value: "customerName",
      groupable: false,
      sortable: true
    },

    {
      text: this.$t("phoneNumber"),
      value: "phoneNumber",
      groupable: false,
      sortable: false
    },
    {
      text: this.$t("email"),
      value: "email",
      groupable: false,
      sortable: false
    },
    {
      text: this.$t("booking.status.label"),
      value: "status",
      groupable: false,
      sortable: false
    },
    {
      text: "",
      value: "data-table-expand",
      groupable: false,
      width: 0,
      sortable: false
    }
  ];

  get dialog() {
    return this.value;
  }

  set dialog(newValue) {
    this.$emit("input", newValue);
    this.page = 0;
    this.bookings = [];
    this.searchString = "";
    this.previousSearchString = "";
    this.resetExpanded();
  }

  get hasNextPage() {
    return this.bookings !== null && this.bookings.length === this.pageSize;
  }

  get hasPreviousPage() {
    return this.page > 0;
  }

  get searchBar() {
    return this.$refs.searchBar as VuetifyTextInput;
  }

  get isSearchByName() {
    return this.tab === 0;
  }

  get isSearchByPhoneNumber() {
    return this.tab === 1;
  }

  getDateTimeDisplayString(dateTimeString: string) {
    return TimeService.getDateTimeDisplayStringFromISO(dateTimeString);
  }

  get hasChanged() {
    return (
      this.previousSearchString !== this.searchString &&
      this.searchString !== ""
    );
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  resetExpanded() {
    this.expanded = [];
  }

  getBookingStatusDisplayString(status: string) {
    return Booking.getBookingStatusDisplayString(status);
  }

  getBookingStatusColour(status: string) {
    return Booking.getBookingStatusDisplayColour(status);
  }

  @Watch("value")
  doInitialSearch() {
    if (
      this.value &&
      this.initialSearch !== "" &&
      this.initialSearch !== null
    ) {
      this.searchString = this.initialSearch.slice();
      this.searchBookings();
    }
  }

  async searchBookings() {
    try {
      if (this.hasChanged) {
        this.loading = true;
        this.bookings = [];
        const restaurant = this.selectedRestaurant;
        if (restaurant != null) {
          if (this.isSearchByName)
            this.bookings = await RemoteServices.searchBookingsCustomerName(
              restaurant,
              this.searchString,
              this.page,
              this.pageSize
            );
          else if (this.isSearchByPhoneNumber)
            this.bookings = await RemoteServices.searchBookingsPhoneNumber(
              restaurant,
              this.searchString,
              this.page,
              this.pageSize
            );
        }
        this.previousSearchString = this.searchString;
        this.searchBar.blur();
      }
    } catch (error) {
      await this.$store.dispatch("error", error.message);
    }
    this.loading = false;
  }

  emitBookingSelected(booking: Booking) {
    this.$emit("booking-selected", booking);
    this.dialog = false;
  }

  nextPage() {
    if (this.hasNextPage) {
      this.page += 1;
      this.searchString = this.previousSearchString;
      this.previousSearchString = "";
      this.searchBookings();
    }
  }

  previousPage() {
    if (this.hasPreviousPage) {
      this.page -= 1;
      this.searchString = this.previousSearchString;
      this.previousSearchString = "";
      this.searchBookings();
    }
  }
}
